import { Button, Box, Typography, Paper, Divider, useTheme } from "@mui/material";
import { useState, useEffect } from "react";
import AddScopeModal from "./AddScopeModal";
import ScopeDetailsModal from "./ScopeDetailsModal";
import { Scope } from "../../types";
import { useScope } from "app/context/ScopeContext";
import DataGridMAIQ from "app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ";
import DataGridTypes from "types/DataGridTypes";
import AddIcon from '@mui/icons-material/Add';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ButtonMAIQ from "app/components/ReusableUIComponents/LowLevelComponents/buttons/ButtonMAIQ";

const ScopesTab = () => {
  const { scopes, getAllScopes } = useScope();
  const [isAddScopeModal, setIsAddScopeModal] = useState(false);
  const [selectedScope, setSelectedScope] = useState<Scope | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    getAllScopes();
  }, [refreshKey]);

  const handleAddScopeModalOpen = () => {
    setIsAddScopeModal(true);
  };

  const handleScopeClick = (scope: any) => {
    setSelectedScope(scope.row);
  };

  const handleCloseScopeDetails = () => {
    setSelectedScope(null);
  };

  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        padding: { xs: 1, sm: 2 }
      }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 2.5,
          display: "flex",
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: "space-between",
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <VpnKeyIcon 
            sx={{ 
              color: theme.palette.primary.main,
              fontSize: 28 
            }} 
          />
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.1rem',
                color: theme.palette.primary.main
              }}
            >
              Scope Management
            </Typography>
            <Typography 
              variant="body2" 
              color="text.primary"
              sx={{ fontSize: '0.85rem' }}
            >
              Create and manage permission scopes
            </Typography>
          </Box>
        </Box>
        
        <ButtonMAIQ
          variant="contained"
          color="primary"
          onClick={handleAddScopeModalOpen}
          startIcon={<AddIcon />}
        >
          Add New Scope
        </ButtonMAIQ>
      </Paper>
      
      <Divider sx={{ opacity: 0.5 }} />

      <Box 
        sx={{ 
          flexGrow: 1, 
          minHeight: 400,
          '& .MuiDataGrid-root': {
            border: 'none',
            borderRadius: 1.5,
            boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          },
        }}
      >
        <DataGridMAIQ 
          key={refreshKey}
          type={DataGridTypes.SCOPES()}
          onRowClick={handleScopeClick}
        />
      </Box>

      <AddScopeModal
        open={isAddScopeModal}
        onClose={() => setIsAddScopeModal(false)}
        onSuccess={() => setRefreshKey(prev => prev + 1)}
      />
      {selectedScope && (
        <ScopeDetailsModal
          open={!!selectedScope}
          onClose={handleCloseScopeDetails}
          scope={selectedScope}
          onSuccess={() => {
            setRefreshKey(prev => prev + 1);
            handleCloseScopeDetails();
          }}
        />
      )}
    </Box>
  );
};

export default ScopesTab; 